<!-- 農場 -->
<template>
    <b-container class="pt-3" fluid>
        <b-container>
            <!-- 智慧農業 -->
            <b-breadcrumb :items="items"></b-breadcrumb>
            <div class="carousel-region">
                <b-row>
                    <b-col cols="5">
                        <carousel :autoplay="true" :margin="10" :loop="true" :nav="false" :items="1">
                            <img v-for="(data, index) in imgData" :key="index" :src="data.src" height="236" width="420"/>
                        </carousel>
                    </b-col>
                    <b-col cols="7">
                        花囍田咖啡莊園，名稱寓意著兩個咖啡家族的結合。男主人謝宗霖先生在自家田地上種植咖啡，開啟了他的咖啡事業。女主人林貝珊小姐為照顧年邁的父母回到故鄉，也加入了咖啡產業，找到新的人生意義。
                        <br>
                        早期的咖啡品種以堤碧卡跟波旁為主，後來才開始做品種更新，近年來更是帶領產銷班，有系統性地行銷、種植草嶺咖啡，並在2021年，在雲林縣的咖啡評鑑裡的20個獲獎名額哩，拿下了其中14個名次。
                    </b-col>
                </b-row>
            </div>
            <!-- 未登入 -->
            <div class="data-region" v-show="!isLogin">
                <b-button @click="isLogin = true">測試登入</b-button>
                <Login_sub></Login_sub>
            </div>
            <!-- 智慧農業各農場詳細資料 -->
            <div class="data-region" v-show="isLogin">
                <b-card title="土壤溫度">
                    <b-card-text>
                        <img src="/static/img/08.png"/>
                    </b-card-text>
                </b-card>
            </div>
            <div class="data-region" v-show="isLogin">
                <b-card title="土壤氮磷鉀即時監測數據">
                    <b-card-text>
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="ths"></th>
                                    <th class="thm">氮含量(N)</th>
                                    <th class="thm">磷含量(P)</th>
                                    <th class="the">鉀含量(K)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="even-row">
                                    <td class="tds tdm"><span>2023.05.26 08:00:00:00</span></td>
                                    <td class="tdm"><span>50 mg/kg</span></td>
                                    <td class="tdm"><span>18 mg/k</span></td>
                                    <td class="tde"><span>78 mg/k</span></td>
                                </tr>
                                <tr class="odd-row">
                                    <td class="tds tdm"><span>2023.05.26 08:00:00:00</span></td>
                                    <td class="tdm"><span>50 mg/kg</span></td>
                                    <td class="tdm"><span>18 mg/k</span></td>
                                    <td class="tde"><span>78 mg/k</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-text>
                </b-card>
            </div>
            <div class="data-region" v-show="isLogin">
                <b-card title="農業感測器感測資料">
                    <b-card-text>
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="ths">station_id</th>
                                    <th class="thm">timestamp</th>
                                    <th class="thm">二氧化碳</th>
                                    <th class="the">光量子</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="even-row">
                                    <td class="tds tdm"><span>H_N202109006</span></td>
                                    <td class="tdm"><span>2023-03-27 09:11:29</span></td>
                                    <td class="tdm"><span>100</span></td>
                                    <td class="tde"><span></span></td>
                                </tr>
                                <tr class="odd-row">
                                    <td class="tds tdm"><span>H_N202109006</span></td>
                                    <td class="tdm"><span>2023-03-27 09:11:29</span></td>
                                    <td class="tdm"><span>100</span></td>
                                    <td class="tde"><span></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-text>
                </b-card>
            </div>
        </b-container>
    </b-container>
</template>

<script>
import Login_sub from '@/components/Login_sub.vue'

export default {
    data() {
        return {
            isLogin:false,
            items: [
                {
                    text: '首頁',
                    href: '#'
                },
                {
                    text: '智慧農場',
                    href: '#/Farm'
                },
                {
                    text: '花田囍咖啡農場',
                    active: true
                }
            ],
            detailTitle: "花田囍咖啡農場",
            imgData: [
                { title: '花田囍咖啡農場', url: "#", src: "https://doqvf81n9htmm.cloudfront.net/data/himnbob_103/10/may/18/22.jpg" },
                { title: '谷泉咖啡莊園', url: "#", src: "https://doqvf81n9htmm.cloudfront.net/data/himnbob_103/10/may/18/22.jpg" },
                { title: '大力有機農場', url: "#", src: "https://doqvf81n9htmm.cloudfront.net/data/himnbob_103/10/may/18/22.jpg" },
                { title: '涌詮生態農場', url: "#", src: "https://doqvf81n9htmm.cloudfront.net/data/himnbob_103/10/may/18/22.jpg" },
                { title: '谷泉咖啡莊園1', url: "#", src: "https://doqvf81n9htmm.cloudfront.net/data/himnbob_103/10/may/18/22.jpg" },
                { title: '大力有機農場1', url: "#", src: "https://doqvf81n9htmm.cloudfront.net/data/himnbob_103/10/may/18/22.jpg" },
                { title: '涌詮生態農場2', url: "#", src: "https://doqvf81n9htmm.cloudfront.net/data/himnbob_103/10/may/18/22.jpg" },
                { title: '大力有機農場2', url: "#", src: "https://doqvf81n9htmm.cloudfront.net/data/himnbob_103/10/may/18/22.jpg" }
            ],
        };
    },
    components: {
        Login_sub
    },
    updated() {
    },
    mounted() {
        console.log(this.$route.query.id);
    },
    methods: {
    },
    watch: {
    }
};
</script>

<style lang="scss">
@import '../assets/farm_detail.scss'
</style>

